import React from 'react';
import { Outlet } from 'react-router-dom';

export const BenchmarkLayout: React.FC = () => {
  return (
    <div className="flex h-full flex-col gap-6 overflow-y-auto p-6">
      <div>
        <h1 className="text-2xl font-bold">Benchmark Dashboard</h1>
        <p className="text-muted-foreground">
          Agent-evaluator experiment trends and aggregate grading signals.
        </p>
      </div>
      <Outlet />
    </div>
  );
};
